// extracted by mini-css-extract-plugin
export default {"cardHeader":"card-with-tick_cardHeader__xizdm","card":"card-with-tick_card__f90E6"};